import type { FaireProductEntity } from "../../entity_types/product";

export const p_a5ekb2w958: FaireProductEntity = {
  token: "p_a5ekb2w958",
  type: "product",
  name: "Pixar The Eternally Grateful Aliens, Thank You - Toy Story Greeting Card",
  brandToken: "b_83j5eoki61",
  brandName: "Minted",
  imageUrl:
    "https://cdn.faire.com/fastly/a8ff3434b8448356578783abe185e287d6f4996aaec7c213bbc19bbffc904b31.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0490cc4867fef572e684a07552d318952020a3e3e7bbd0abf830d8f97eea2094.png",
    "https://cdn.faire.com/fastly/98b596e21e2076c812b361b8d5617d350099e35e20575caff99fe69befda9b5f.jpeg",
  ],
  priceDollars: 3,
  description:
    'Spread love, light, and joy with an artist-designed greeting card. Minted is a community-driven marketplace of stationery, art, decor, and gifts designed by independent artists and makers around the world. Every purchase supports the artist behind the design.\n\nAbout this product:\n• This greeting card is designed by Sweta Modi, a Minted artist from Mumbai, India\n• This folded card measures 5 inches by 7 inches\n• Interior message: "Thank you!"\n• Luxe paper quality: each greeting card is printed on 350 gsm uncoated paper stock\n• Each card is paired with one A7 White envelope\n\nInformation for retail buyers:\n• Each wholesale unit contains 4 retail units\n• Each wholesale unit contains a caption locator card with "THANK YOU - Toy Story" printed on the top.\n• Each retail unit is in cello wrap\n• Each retail unit contains one card and one envelope\n• Each retail unit contains an insert that displays retail price and UPC barcode\n',
  tags: [],
  msrpDollars: 5.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:04.380Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
